import { useCallback, useState } from "react";

/**
 * Hook to read the current GPS position once via the browser geolocation API.
 * Returns { getPosition, loading, error, supported }
 */
export function useGeolocation() {
  const supported = typeof navigator !== "undefined" && "geolocation" in navigator;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getPosition = useCallback(
    (opts = {}) => {
      return new Promise((resolve, reject) => {
        if (!supported) {
          const e = new Error("Geolocalización no disponible");
          setError(e);
          reject(e);
          return;
        }
        setLoading(true);
        setError(null);
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            setLoading(false);
            resolve({
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
              accuracy: pos.coords.accuracy,
              timestamp: pos.timestamp,
            });
          },
          (err) => {
            setLoading(false);
            setError(err);
            reject(err);
          },
          { enableHighAccuracy: true, timeout: 12_000, maximumAge: 30_000, ...opts }
        );
      });
    },
    [supported]
  );

  return { supported, loading, error, getPosition };
}
